import React from 'react';
import _, { isEqual } from 'lodash';
import { Input, Button, Checkbox, Tooltip } from 'antd';
import moment from 'moment';
import { HelpIcon } from './Icons';

const GEQ = '>=', LEQ = '<=';

export const ComparisonTypes = {
    GEQ,
    LEQ
}

class ColumnFilterComparison extends React.Component {
    // used in filter bar to display filter values
    static formatter(str, label='Days'){
        const { searchTextGEQ, searchTextLEQ } = ColumnFilterComparison.parseValues(str);
        const textArray = [];
        if(searchTextGEQ){
            textArray.push(`${GEQ} ${searchTextGEQ}`);
        }
        if(searchTextLEQ){
            textArray.push(`${LEQ} ${searchTextLEQ}`);
        }
        if(textArray.length > 1){
            textArray.splice(1, 0, 'And');
        }
        if(textArray.length > 0){
            textArray.push(label);
        } else {
            textArray.push('N/A');
        }
        return textArray.join(' ');
    }
    // for age filter
    static toDates(str) {
        const { searchTextGEQ, searchTextLEQ } = ColumnFilterComparison.parseValues(str);
        let startDate, endDate;
        
        if(_.isEmpty(searchTextGEQ)){
            endDate = moment();
        } else {
            endDate = moment().add(-1 * searchTextGEQ, 'days');
        }

        if(_.isEmpty(searchTextLEQ)){
            startDate = moment(0);
        } else {
            startDate = moment().add(-1 * searchTextLEQ, 'days');
        }

        startDate = startDate.startOf('D').toDate().toUTCString();
        endDate = endDate.endOf('D').toDate().toUTCString();
        return {
            startDate,
            endDate
        }
    }

    // Give the future Date on basis of input
    static toFutureDates(str) {
        const { searchTextGEQ, searchTextLEQ } = ColumnFilterComparison.parseValues(str);
        let startDate, endDate;
        if(_.isEmpty(searchTextGEQ)){
            startDate = moment();
        } else {
            startDate = moment().add(+searchTextGEQ, 'days');
        }

        if(_.isEmpty(searchTextLEQ)){
            endDate = moment().add('10', 'year');
        } else {
            endDate = moment().add(+searchTextLEQ, 'days');
        }

        if(endDate.isBefore(startDate)){
            [startDate, endDate] = [endDate, startDate];
        }

        startDate = startDate.startOf('D').toDate().toUTCString();
        endDate = endDate.endOf('D').toDate().toUTCString();
        return {
            startDate,
            endDate
        }
    }
    static parseValues(str) {
        if (_.isNull(str)) {
            return {};
        }
        if(_.isString(str)){
            str = [str];
        }
        let searchTextGEQ, searchTextLEQ;
        // this condition is for bactward compatibility, we had only 1 have either LTE or GTE (<= 1, >= 1)
        if(str.length === 1){
            if (_.isNull(str[0])) {
                return {};
            }
            const [comparator, searchTextValue] = str[0].trim().split(' ');
            let searchText = searchTextValue;
            if (isNaN(searchText)) {
                searchText = '';
            }
            if(comparator === GEQ){
                searchTextGEQ = searchText;
                searchTextLEQ = '';
            } else {
                searchTextGEQ = '';
                searchTextLEQ = searchText;
            }
        } else {
            //since score comparison and finding age filters accept null values
            //send empty string if one of the filter is null
            searchTextGEQ = _.isNil(str[0])  ? '' : str[0] + '';
            searchTextLEQ = _.isNil(str[1])  ? '' : str[1] + '';
        }
        return {
            searchTextGEQ,
            searchTextLEQ
        }
    }
    inputRef = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchTextGEQ: '',
            searchTextLEQ: '',
            comparator: GEQ,
            selected: [],
            nullFilter: false,
            showNullFilter: props.hasOwnProperty('nullFilterValue') && !_.isUndefined(props.nullFilterValue),
            changed: false,
        }
        _.bindAll(
            this,
            'searchChanged',
            'applyFilter',
            'clearFilter',
            'comparatorChanged',
            'toggleNullFilter'
        )
    }
    searchChanged(e) {
        const value = (''+e.target.value);
        this.setState({
            [e.target.id]: value.length > 10 ? value.substring(0, 10) : value,
            changed: true,
        });
    }
    focusInput() {
        if (this.inputRef.current) {
            this.focusTimeOut = setTimeout(() => {
                this.inputRef.current.select();
            }, 300);
        }
    }
    componentWillUnmount() {
        if (!_.isUndefined(this.focusTimeOut)) {
            clearTimeout(this.focusTimeOut);
        }
    }
    componentDidMount() {
        this.setValue();
    }
    componentDidUpdate(prevProps) {
        const { visible, selectedKeys } = this.props;
        if (prevProps.visible !== visible) {
            if (visible) {
                this.setState({ changed: false });
                this.setValue();
            }
        } else if(!isEqual(selectedKeys, prevProps.selectedKeys)) {
            this.setValue();
        }
    }
    setValue() {
        const { selectedKeys, receiveInterceptor } = this.props;
        //disable fields when 'Search blank records' is checked
        const isNull = selectedKeys.length === 1 && _.isNull(selectedKeys[0]);
        this.setState({ nullFilter: isNull, searchText: isNull ? 'N/A' : '' });
        if (selectedKeys.length) {
            let { searchTextGEQ, searchTextLEQ } = ColumnFilterComparison.parseValues(selectedKeys);
            [searchTextGEQ, searchTextLEQ] = receiveInterceptor([searchTextGEQ, searchTextLEQ]);
            this.setState({ searchTextGEQ, searchTextLEQ }, this.focusInput);
        } else {
            this.setState({
                searchTextGEQ: '',
                searchTextLEQ: ''
            });
            this.focusInput();
        }
    }
    applyFilter() {
        const { confirm, setSelectedKeys, applyInterceptor, onUpdateValues } = this.props;
        const { searchTextGEQ, searchTextLEQ, nullFilter } = this.state;

        const value = nullFilter ? [null] : (searchTextGEQ || searchTextLEQ) ? applyInterceptor([searchTextGEQ, searchTextLEQ]) : [];

        onUpdateValues && onUpdateValues(value);
        setSelectedKeys(value);
        confirm();
    }
    clearFilter() {
        const { clearFilters } = this.props;
        this.setState({
            ...this.state,
            searchTextGEQ: '',
            searchTextLEQ: ''
        });
        clearFilters();
    }
    toggleNullFilter(){
        const nullFilter = !this.state.nullFilter;
        const stateObject = {
            nullFilter,
            changed: true,
        }
        if(nullFilter){
            stateObject.searchTextGEQ = stateObject.searchTextLEQ = '';
        }
        this.setState(stateObject);
    }
    comparatorChanged(e) {
        this.setState({
            comparator: e
        })
    }
    render() {
        const { searchTextGEQ, searchTextLEQ, nullFilter, showNullFilter } = this.state;
        const { filterLabel, showHelpText } = this.props;
        return (
            <div className="column-filter ">
                <div className="p-xs">
                    <Input.Group compact>
                        <Input
                            prefix={GEQ}
                            disabled={nullFilter}
                            min={0}
                            max={1000}
                            type="number"
                            style={{ width: 80 }}
                            // placeholder="Search"
                            id="searchTextGEQ"
                            value={searchTextGEQ}
                            onChange={this.searchChanged}
                            onPressEnter={this.applyFilter}
                            ref={this.inputRef}
                        />
                        <div className="m-t-xs m-l-xs p-r-xs">And</div>
                        <Input
                            prefix={LEQ}
                            disabled={nullFilter}
                            min={0}
                            max={1000}
                            type="number"
                            style={{ width: 80 }}
                            id="searchTextLEQ"
                            value={searchTextLEQ}
                            onChange={this.searchChanged}
                            onPressEnter={this.applyFilter}
                        />
                        <div className="m-t-xs m-l-xs">
                            {filterLabel}
                            {showHelpText && <Tooltip className="m-l-xs" placement="right" title="Use hyphen(-) symbol to view past due findings"><HelpIcon /> </Tooltip>}
                        </div>
                        
                    </Input.Group>
                    
                    {showNullFilter && <div className="m-x-xs m-t-xs text-right" >Search blank records <Checkbox checked={nullFilter} onChange={this.toggleNullFilter} /></div>}
                </div>
                
                <div className="ant-table-filter-dropdown-btns">
                    <Button size="small" type="link" onClick={this.clearFilter}>Clear</Button>
                    <Button type="primary" size="small" onClick={this.applyFilter} disabled={!this.state.changed}>Apply</Button>
                </div>
            </div>
        );
    }
}

ColumnFilterComparison.defaultProps = {
    filterLabel: 'Days'
}

export default ColumnFilterComparison;
